import {
  createContext,
  ReactNode,
  useState,
  useContext,
  useEffect,
  useCallback,
} from "react";
import { Banner } from "../@data/banner";
import { collection, getDocs, query } from "firebase/firestore";
import { firestore } from "../services/firebase";
import { useHistory } from "react-router-dom";

export interface BannersContextModel {
  banners: Banner[];
  loadingBanners: boolean;
  autoPlayBannersCarosel: boolean;
  openBannerDetails: (bannerClicked: Banner) => void;
  setAutoPlayBannersCarosel: (autoPlay: boolean) => void;
}

export const BannersContext = createContext<BannersContextModel>(
  {} as BannersContextModel
);

export const BannersProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const history = useHistory();
  const [banners, setBanners] = useState<Banner[]>([] as Banner[]);
  const [loadingBanners, setLoadingBanners] = useState<boolean>(true);
  const [autoPlayBannersCarosel, setAutoPlayBannersCarosel] =
    useState<boolean>(true);

  const handleGetBanners = useCallback(async () => {
    const q = query(collection(firestore, "banners"));
    getDocs(q)
      .then((snapshot) => {
        let bannersData = [] as Banner[];
        snapshot.forEach((banner) =>
          bannersData.push({
            ...(banner.data() as Banner),
            bannerId: banner.id,
          })
        );
        setBanners(bannersData);
      })
      .finally(() => setLoadingBanners(false));
  }, []);

  const handleOpenBannerDetails = useCallback(
    (bannerClicked: Banner) => {
      history.push(`/banner/${bannerClicked.bannerId}`);
    },
    [history]
  );

  useEffect(() => {
    handleGetBanners();
  }, [handleGetBanners]);

  return (
    <BannersContext.Provider
      value={{
        banners,
        autoPlayBannersCarosel,
        loadingBanners,
        openBannerDetails: handleOpenBannerDetails,
        setAutoPlayBannersCarosel: (autoPlay) =>
          setAutoPlayBannersCarosel(autoPlay),
      }}
    >
      {children}
    </BannersContext.Provider>
  );
};

export const useBanners = () => useContext(BannersContext);
